export const buttonBorderRadius = '2px';
